import type { Editor } from '@tiptap/react';

export function resolveTopLevelBlockAt(
  editor: Editor,
  coords: { x: number; y: number },
): { pos: number; dom: HTMLElement } | null {
  const target = document.elementFromPoint(coords.x, coords.y);
  if (!target) return null;

  const contentEl = editor.view.dom;
  let current: Element | null = target;

  while (current && current !== contentEl && current.parentElement !== contentEl) {
    current = current.parentElement;
  }

  if (!current || current === contentEl || !(current instanceof HTMLElement)) return null;

  const nodePos = resolvePosFromDOM(editor, current);
  if (nodePos === null) return null;

  return { pos: nodePos, dom: current };
}

export function resolvePosFromDOM(editor: Editor, dom: HTMLElement): number | null {
  try {
    const pos = editor.view.posAtDOM(dom, 0);
    const $pos = editor.state.doc.resolve(pos);
    const nodePos = $pos.depth >= 1 ? $pos.before(1) : pos;
    if (!editor.state.doc.nodeAt(nodePos)) return null;
    return nodePos;
  } catch {
    return null;
  }
}
